<div class="container p-2">
  <div class="mat-dialog-content text-center mb-3">
    <p>Are you sure you want to {{ title }} ?</p>
  </div>

  <div class="d-flex justify-content-center gap-5">
    <button class="ex2" mat-raised-button (click)="reject()">Yes</button>
    <button class="ex1" matButton (click)="close()">No</button>
  </div>
</div>
